import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [role, setRole] = useState(null);
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);

  // const fetchData = () => {
  //   Http.get("/production").then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };
  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/kitchen-transfer`);
      const resRole = await Http.get(`/staff-type-check`);
      setReceiveData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);
  const cols = [
    { field: "created_at", header: "Receive Date" },
    { field: "receipt_no", header: "Receipt No" },
    { field: "product.name", header: "Product" },
    { field: "qty", header: " Quantity" },
    // { field: "qty", header: "Quantity" },
    // {
    //   field: (item) =>
    //     item.receive_status != 1 ? (
    //       <Link
    //         to={{
    //           pathname: "/production-receive/" + item.id,
    //         }}
    //         className="btn btn-info btn-sm"
    //       >
    //         Receive
    //       </Link>
    //     ) : (
    //       <p className="btn btn-success btn-sm">
    //         <i className="fa fa-check"></i>
    //       </p>
    //     ),
    //   header: "Receive",
    // },
  ];

  const actionTemplate = (item) => {
    return (
      <div className="btn-group" role="group">
        <Link
          to={"/show-production/" + item.id}
          className="btn btn-info btn-sm"
          title="View Details"
        >
          <i className="fa fa-eye"></i>
        </Link>
        &nbsp;
        <Link
          to={"/edit-production/" + item.id}
          className="btn btn-primary btn-sm"
          title="Edit"
        >
          <i className="fa fa-edit"></i>
        </Link>
      </div>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Items</h5>
            {role == "production" && (
              <Link to="/create-production" className="btn btn-primary">
                <i className="fa fa-plus-square mg-r-6"></i>New
              </Link>
            )}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
             
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                // deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
